/**
 * Customer Club popup controller (dialogs are rendered server-side by snippets/customer-club-popup.liquid).
 *
 * Triggers (event delegation):
 *   signup: [data-club-popup-open]  or  a[href="#customer-club-signup"]
 *   login:  [data-club-login-open]  or  a[href="#customer-club-login"]
 *   close:  [data-club-popup-close]
 */
(function () {
  if (window.__customerClubPopupInit) return;
  window.__customerClubPopupInit = true;

  var SUCCESS_KEY = 'cc_club_welcome';
  var SCROLL_KEY = 'cc_reload_scroll';

  // Put the page back where it was after a reload (shared "y@path" key with child-signup-guide.js)
  function restoreScroll() {
    var root = document.documentElement;
    // layout/theme.liquid reads the key early (it hides the page meanwhile); null = already used by the other script
    var y = window.__ccRestoreY;
    if (y === null) return;
    if (y === undefined) {
      var saved = '';
      try {
        saved = sessionStorage.getItem(SCROLL_KEY) || '';
        sessionStorage.removeItem(SCROLL_KEY);
      } catch (e) {}
      var at = saved.indexOf('@');
      // Only on the page it was saved for (a failed native login lands on /account/login)
      y = at > 0 && saved.slice(at + 1) === window.location.pathname ? parseInt(saved.slice(0, at), 10) || 0 : 0;
    }
    window.__ccRestoreY = null;
    if (y <= 0) {
      root.classList.remove('cc-restoring');
      return;
    }
    // Jump at once, then keep correcting while the page grows (images, apps) until it is tall enough.
    // The browser's own restore is left on, since it runs before the first paint.
    var tries = 0;
    var timer = null;
    function jump() {
      window.scrollTo({ top: y, behavior: 'instant' });
    }
    function stop() {
      clearInterval(timer);
      root.classList.remove('cc-restoring');
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (name) {
        window.removeEventListener(name, stop);
      });
    }
    jump();
    timer = setInterval(function () {
      jump();
      if (Math.abs(window.pageYOffset - y) < 2 || ++tries > 30) stop();
    }, 100);
    // The visitor scrolling by hand wins
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (name) {
      window.addEventListener(name, stop, { passive: true });
    });
  }
  restoreScroll();

  function init() {
    var config = document.querySelector('[data-club-popup-config]');
    if (config && config.getAttribute('data-is-member') === 'true') {
      // Hide signup links for members.
      document.body.classList.add('is-club-member');
    }
    if (config && config.getAttribute('data-is-logged-in') === 'true') {
      // Hide login links for logged-in customers.
      document.body.classList.add('is-logged-in');
    }

    var signupDialog = document.getElementById('customer-club-popup');
    var loginDialog = document.getElementById('customer-login-popup');
    var successEl = signupDialog ? signupDialog.querySelector('[data-club-popup-success]') : null;
    var formEl = signupDialog ? signupDialog.querySelector('[data-club-popup-form]') : null;

    // ---- Scroll lock ----
    // The theme's anchor-link handler calls window.scrollTo, which preventDefault() can't stop,
    // so <body> is pinned while a popup is open. The position is read before the click fires.
    var savedScrollY = 0;
    var preClickScroll = null;

    function snapshotScroll() {
      preClickScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    document.addEventListener('mousedown', snapshotScroll, true);
    document.addEventListener('touchstart', snapshotScroll, true);

    function lockScroll() {
      if (document.body.classList.contains('cc-scroll-locked')) return;
      savedScrollY = preClickScroll != null
        ? preClickScroll
        : (window.pageYOffset || document.documentElement.scrollTop || 0);
      preClickScroll = null;
      // Inline styles, so the lock works even if the snippet CSS is outdated.
      var s = document.body.style;
      // Compensate for the scrollbar that disappears when <body> is fixed.
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) s.paddingRight = sbw + 'px';
      s.position = 'fixed';
      s.left = '0';
      s.right = '0';
      s.width = '100%';
      s.overflow = 'hidden';
      s.top = (-savedScrollY) + 'px';
      document.body.classList.add('cc-scroll-locked');
    }

    function unlockScroll() {
      if (!document.body.classList.contains('cc-scroll-locked')) return;
      // Disable smooth scrolling so the position is restored instantly.
      var html = document.documentElement;
      var prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      document.body.classList.remove('cc-scroll-locked');
      var s = document.body.style;
      s.position = '';
      s.left = '';
      s.right = '';
      s.width = '';
      s.overflow = '';
      s.top = '';
      s.paddingRight = '';
      window.scrollTo(0, savedScrollY);
      html.style.scrollBehavior = prevBehavior;
    }

    // The body is pinned while a popup is open, so the real position is savedScrollY
    function rememberScroll() {
      var y = document.body.classList.contains('cc-scroll-locked')
        ? savedScrollY
        : window.pageYOffset;
      try { sessionStorage.setItem(SCROLL_KEY, y + '@' + window.location.pathname); } catch (e) {}
    }

    function openDialog(dialog) {
      if (!dialog || dialog.open) return;
      // Join mode (logged-in non-member): pre-check the club opt-in.
      if (dialog.classList.contains('customer-club-popup--join')) {
        var clubToggle = dialog.querySelector('#toggle-customerclub');
        if (clubToggle) clubToggle.checked = true;
      }
      lockScroll();
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      unlockScroll();
    }

    function showSuccess() {
      if (!successEl) return;
      if (formEl) formEl.hidden = true;
      successEl.hidden = false;
    }

    // ---- Login: show errors inside the popup ----
    // POST via fetch; with captcha enforced it falls back to a native submit.
    function setupInlineLogin(dialog) {
      if (!dialog) return;
      var loginForm = dialog.querySelector('form');
      if (!loginForm) return;

      loginForm.addEventListener('submit', function (e) {
        // Saved before the captcha / native submit too, which loads the page from the top
        rememberScroll();
        if (window.Shopify && window.Shopify.captcha) return;

        e.preventDefault();
        clearLoginError(loginForm);
        var btn = loginForm.querySelector('button[type="submit"], button:not([type])');
        if (btn) btn.disabled = true;

        fetch(loginForm.action, {
          method: 'POST',
          body: new FormData(loginForm),
          headers: { 'X-Requested-With': 'fetch' }
        })
          .then(function (r) {
            return r.text().then(function (html) {
              return { url: r.url || '', redirected: r.redirected, html: html };
            });
          })
          .then(function (res) {
            var onLoginPage = res.url.indexOf('/account/login') !== -1;
            if (res.redirected && !onLoginPage) {
              // Logged in: reload so the page reflects the session
              unlockScroll();
              window.location.reload();
              return;
            }
            // Login failed and the page stays: drop the saved position so a later visit isn't moved
            try { sessionStorage.removeItem(SCROLL_KEY); } catch (e) {}
            showLoginError(loginForm, extractLoginError(res.html));
            if (btn) btn.disabled = false;
          })
          .catch(function () {
            loginForm.submit();
          });
      });
    }

    function extractLoginError(html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var alert = doc.querySelector('#login .alert, .text-error-text');
        if (alert) return alert.textContent.trim();
      } catch (e) {}
      return null;
    }

    function clearLoginError(form) {
      var el = form.querySelector('[data-login-error]');
      if (el) el.remove();
    }

    function showLoginError(form, message) {
      var el = form.querySelector('[data-login-error]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-login-error', '');
        el.className = 'alert mb-8 bg-error-bg text-error-text';
        el.setAttribute('tabindex', '-1');
        form.insertBefore(el, form.firstChild);
      }
      el.textContent = message || 'Forkert mail eller adgangskode.';
      el.focus();
    }

    // ---- Reset password: replaces the login form in the popup ----
    // Like login: fetch, then read the result from the page Shopify redirects to.
    function showRecover(dialog, show) {
      var loginView = dialog.querySelector('[data-login-view]');
      var recoverView = dialog.querySelector('[data-recover-view]');
      if (!loginView || !recoverView) return;
      loginView.hidden = show;
      recoverView.hidden = !show;
      if (show) {
        var recoverForm = recoverView.querySelector('form');
        var success = recoverView.querySelector('[data-recover-success]');
        if (recoverForm) recoverForm.hidden = false;
        if (success) success.hidden = true;
        var email = recoverView.querySelector('input[type="email"]');
        var loginEmail = loginView.querySelector('input[type="email"]');
        if (email && loginEmail && !email.value) email.value = loginEmail.value;
        if (email) email.focus();
      }
    }

    function setupInlineRecover(dialog) {
      if (!dialog) return;
      var recoverView = dialog.querySelector('[data-recover-view]');
      var recoverForm = recoverView ? recoverView.querySelector('form') : null;
      if (!recoverForm) return;

      recoverForm.addEventListener('submit', function (e) {
        if (window.Shopify && window.Shopify.captcha) return;

        e.preventDefault();
        clearRecoverError(recoverForm);
        var btn = recoverForm.querySelector('button');
        if (btn) btn.disabled = true;

        fetch(recoverForm.action, {
          method: 'POST',
          body: new FormData(recoverForm),
          headers: { 'X-Requested-With': 'fetch' }
        })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var errorEl = doc.querySelector('#recover .form__field-error');
            if (btn) btn.disabled = false;
            if (errorEl && errorEl.textContent.trim()) {
              showRecoverError(recoverForm, errorEl.textContent.trim());
            } else if (doc.querySelector('#recover .bg-success-bg')) {
              recoverForm.hidden = true;
              var success = recoverView.querySelector('[data-recover-success]');
              if (success) {
                success.hidden = false;
                success.focus();
              }
            } else {
              recoverForm.submit();
            }
          })
          .catch(function () {
            recoverForm.submit();
          });
      });
    }

    function clearRecoverError(form) {
      var el = form.querySelector('[data-recover-error]');
      if (el) el.remove();
    }

    function showRecoverError(form, message) {
      var el = form.querySelector('[data-recover-error]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-recover-error', '');
        el.className = 'alert mb-8 bg-error-bg text-error-text';
        el.setAttribute('tabindex', '-1');
        form.insertBefore(el, form.firstChild);
      }
      el.textContent = message;
      el.focus();
    }

    setupInlineLogin(loginDialog);
    setupInlineRecover(loginDialog);

    // The signup form pushes a dataLayer event on success; flag it so the welcome message
    // is shown again after the post-signup login redirect.
    var dl = (window.dataLayer = window.dataLayer || []);
    var originalPush = dl.push;
    dl.push = function () {
      for (var i = 0; i < arguments.length; i++) {
        var entry = arguments[i];
        if (entry && entry.event === 'customer_club_signup') {
          try { sessionStorage.setItem(SUCCESS_KEY, '1'); } catch (e) {}
          showSuccess();
          openDialog(signupDialog);
        }
      }
      return originalPush.apply(this, arguments);
    };

    // Capture phase, so theme handlers that stop propagation can't let the anchor jump the page.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-club-popup-open], a[href="#customer-club-signup"]')) {
        e.preventDefault();
        openDialog(signupDialog);
        return;
      }
      if (e.target.closest('[data-club-login-open], a[href="#customer-club-login"]')) {
        e.preventDefault();
        openDialog(loginDialog);
        return;
      }
      if (e.target.closest('[data-recover-open]')) {
        e.preventDefault();
        showRecover(loginDialog, true);
        return;
      }
      if (e.target.closest('[data-recover-close]')) {
        e.preventDefault();
        showRecover(loginDialog, false);
        return;
      }
      var closeBtn = e.target.closest('[data-club-popup-close]');
      if (closeBtn) {
        e.preventDefault();
        closeDialog(closeBtn.closest('dialog'));
      }
    }, true);

    [signupDialog, loginDialog].forEach(function (dialog) {
      if (!dialog) return;
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeDialog(dialog); // backdrop click
      });
      // Also covers Esc, which closes a native <dialog> without our close handler.
      dialog.addEventListener('close', function () {
        unlockScroll();
        if (dialog === loginDialog) showRecover(loginDialog, false);
      });
    });

    // Just signed up: show the welcome message.
    var welcomed = false;
    try { welcomed = sessionStorage.getItem(SUCCESS_KEY) === '1'; } catch (e) {}
    if (welcomed) {
      try { sessionStorage.removeItem(SUCCESS_KEY); } catch (e) {}
      showSuccess();
      openDialog(signupDialog);
    } else if (window.location.hash === '#customer-club-signup') {
      openDialog(signupDialog);
    } else if (window.location.hash === '#customer-club-login') {
      openDialog(loginDialog);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
